{
  "DarkMode_Switch_Title": "Modo escuro",
  "NAME": "DarkMode",
  "DarkMode_SwitchLight_Title": "Modo claro"
}